<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    ref="table"
  >
  </cTable>
</template>

<script>
import {clearAmount, getAmount, getFlow, rechargeAmount,} from "@/api/finance/flow";
import {getAllClient, getCompanies, searchClient} from "@/api/user/client";
import {getBank} from "@/api/finance/bank";
import cTable from "@/base/common/index";

export default {
  name: "flow",
  components: {
    cTable,
  },
  mounted() {
    this.header.searchs.forEach(async (item) => {
      if (item.key === "client_id")
        // item.options = (await getAllClient()).data.payload.rows;
      if (item.key === "ownership")
        item.options = (await getCompanies()).data.payload;
    });
  },
  data() {
    return {
      isShow: false,
      methods: {
        list: getFlow,
        rechargeAmount,
        clearAmount,
        getAmount,
        getAllClient,
        getBank,
        getCompanies,
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let type =
                row.type == "recharge" ? "rechargeAmount" : "clearAmount";
              delete row.clientAmount;
              this.$page
                .handleRequestMethods(type, row, true, true)
                .then((res) => {
                  this.$page.getList();
                  close();
                });
            },
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true,
            },
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              amount: [
                {
                  required: true,
                  type: "number",
                  message: "Please enter the amount",
                  trigger: "blur",
                },
              ],
              currency_type: [
                {
                  required: true,
                  type: "string",
                  message: "Please select the currency type",
                  trigger: "change",
                },
              ],
              client_id: [
                {
                  required: true,
                  type: "number",
                  message: "Please select the client",
                  trigger: "change",
                },
              ],
              bank_id: [
                {
                  required: true,
                  type: "number",
                  message: "Please select the client",
                  trigger: "change",
                },
              ],
              transtion_id: [
                {
                  required: true,
                  message: "Please Enter transtion_id",
                  trigger: "blur",
                },
              ],
              cw_remarks: [
                {
                  required: true,
                  message: "Please Enter Remarks",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            { client_id: 24 },
            { currency_type: 24 },
            { clientAmount: 24 },
            { amount: 24 },
            { bank_id: 24 },
            { transtion_id: 24 },
            { preview_image: 24 },
            { cw_remarks: 24 },
          ],
          fields: [
            {
              name: () => this.$t("clientName"),
              key: "client_id",
              component: "SelectSearchable",
              options: [],
              config: {
                value: "id",
                label: "account",
              },
              filterable: true,
              placeholder() {
                return this.$t("select") + this.$t("clientName");
              },
              methods: {
                "remote-method"({field, formData}, $event) {
                  if ($event.length >= 2) {
                    searchClient({keywords: $event}).then(res => {
                      field.options = res.data.payload.rows
                    })
                  }
                },
                "on-change"({ row, formData }) {
                  if (row.client_id && row.currency_type) {
                    getAmount({
                      client_id: row.client_id,
                      currency_type: row.currency_type,
                    }).then((res) => {
                      formData.clientAmount = res.data.payload;
                    });
                  }
                },
              },
            },
            {
              name: () => this.$t("currencyType"),
              key: "currency_type",
              component: "Select",
              options: [
                { value: "CNY", label: "to_rmb" },
                { value: "USD", label: "to_usd" },
              ],
              config: {
                value: "value",
                label: ({ row }) => {
                  return this.$t(row.label);
                },
              },
              placeholder() {
                return this.$t("select") + this.$t("currencyType");
              },
              methods: {
                "on-change"({ row, formData }) {
                  if (row.client_id && row.currency_type) {
                    getAmount({
                      client_id: row.client_id,
                      currency_type: row.currency_type,
                    }).then((res) => {
                      formData.clientAmount = res.data.payload;
                    });
                  }
                },
              },
            },
            {
              name: () => this.$t("account_balances"),
              key: "clientAmount",
              component: "Input",
              disabled: true,
              default: 0,
            },
            {
              name: () => this.$t("reChAmount"),
              key: "amount",
              component: "InputNumber",
              default: 0,
              bind: {
                style: {
                  width: "100%",
                },
                step: 0.01,
                min: 0,
              },
            },
            {
              name: () => this.$t("bank_code"),
              key: "bank_id",
              component: "Select",
              options: [],
              config: {
                label: ({ row }) => row.account_type + " - " + row.bank_code,
                value: "id",
              },
              placeholder() {
                return this.$t("select") + this.$t("bank_code");
              },
              methods: {
                async list({ field }) {
                  field.options = (
                    await this.$page.handleRequestMethods("getBank")
                  ).payload;
                  this.$forceUpdate();
                },
              },
              show: () => {
                return this.isShow;
              },
            },
            {
              name: () => this.$t("transaction_id"),
              key: "transtion_id",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("transaction_id");
              },
              show: () => {
                return this.isShow;
              },
            },
            {
              name: () => this.$t("Remarks"),
              key: "cw_remarks",
              component: "Input",
              placeholder() {
                return this.$t("select") + this.$t("Remarks");
              },
              bind: {
                type: "textarea",
                rows: 5,
              },
            },
            {
              name: () => this.$t("附件上传"),
              key: "preview_image",
              component: "Upload-img",
              bind: {
                type: "drag",
                accept: ".jpg,.png,.webp,.jpeg",
                multiple: true,
                fileName: "files",
              },
              methods: {
                beforeUpload: ({ file, formData }) => {
                  const reader = new FileReader();

                  // 当文件读取成功后触发
                  reader.onload = function(e) {
                     // 这就是转换后的 Base64 编码
                    formData.preview_image = e.target.result
                  };

                  // 开始将文件读取为 Data URL (即 Base64 编码)
                  reader.readAsDataURL(file);
                  return false;
                },
              }
            },
          ],
        },
      },
      footer: { show: () => true },
      header: {
        searchs: [
          {
            key: "startTime",
            placeholder() {
              return this.$t("select") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              type: "datetime",
              style: {
                width: "180px",
              },
            },
          },
          {
            key: "endTime",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              type: "datetime",
              style: {
                width: "180px",
              },
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              },
            },
          },
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "SelectSearchable",
            options: [],
            config: {
              label: "account",
              value: "id",
            },
            filterable: true,
            methods: {
              "remote-method"({field, formData}, $event) {
                if ($event.length >= 2) {
                  searchClient({keywords: $event}).then(res => {
                    field.options = res.data.payload.rows
                  })
                }
              },
            }
          },
          {
            key: "ownership",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            component: "Select",
            options: [],
            config: {
              label: "title",
              value: "id",
            },
          },
          {
            key: "sourceChannel",
            placeholder() {
              return this.$t("渠道来源");
            },
            component: "Select",
            options: [
              {value: 'AliPay', label: '支付宝'},
              {value: 'WePay', label: '微信支付'},
              {value: 'recharge', label: '线下充值'},
              {value: 'Deduct', label: '扣费'},
              {value: 'Check', label: '支票'},
              {value: 'BankTransfer', label: '银行转账'},
              {value: '-1', label: '其他'},
            ],
          },
          {
            key: "transtion_id",
            placeholder() {
              return this.$t("支付宝订单号");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 1, maxRows: 2 },
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("recharge"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "error",
              },
              id: 350,
            },

            {
              name: () => this.$t("payBalance"),
              type: "payBalance",
              fnName: "payBalance",
              bind: {
                icon: "md-remove",
                type: "success",
              },
              id: 351,
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary",
              },
            },
          ],
          methods: {
            export() {
              this.exportExc();
            },
            add: () => {
              this.$refs["table"].getModal("add").setTitle(this.$t("recharge"));
              this.isShow = true;
              this.$refs["table"].getModal("add").open({ type: "recharge" });
            },
            payBalance: () => {
              this.isShow = false;
              this.$refs["table"]
                .getModal("add")
                .setTitle(this.$t("payBalance"));
              this.$refs["table"].getModal("add").open();
            },
            cancelHang() {
              let data = {
                ids: this.selectAll.map((item) => item.id),
              };
              this.$Modal.confirm({
                title: this.$t("cancel") + this.$t("hang"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("cancelHangStatus", data).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
          fixed: "left",
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          width: 170,
        },
        {
          name: () => this.$t("flow_num"),
          key: "order_no",
          width: 220,
          render: (h, { row }) => {
            console.log(row);
            if (row.bill_proof) {
              return h('Button', {
                props: {
                  type: "warning",
                },
                on: {
                  click: () => {
                    window.open(row.bill_proof)
                  }
                }
              }, row.order_no)
            } else {
              return h('div', {}, row.order_no)
            }
          }
        },
        {
          name: () => this.$tz("支付宝订单号"),
          key: "transtion_id",
          minWidth: 180,
        },
        {
          name: () => this.$t("clientName"),
          key: "clientInfo",
          align: "left",
          minWidth: 130,
          methods: {
            render({ value }) {
              return value && value.account;
            },
          },
        },
        {
          name: () => this.$t("ownership"),
          key: "ownership_name",
          align: "left",
          minWidth: 150,
        },
        {
          name: () => this.$t("currencyType"),
          key: "currency",
          align: "center",
          width: 80,
        },
        {
          name: () => this.$t("change_amount"),
          align: "left",
          key: "change_amount",
          minWidth: 80,
          render: (h, { row }) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: row.pay_action == "less" ? "#19be6b" : "#Ed4014",
                    fontSize: "15px",
                    fontWeight: "600",
                  },
                },
                row.change_amount
              ),
            ]);
          },
        },
        {
          name: () => this.$t("account_balances"),
          key: "after_balance",
          align: "left",
          minWidth: 80,
        },
        {
          name: () => this.$t("pay_way"),
          align: "left",
          key: "pay_way",
          width: 80,
        },
        {
          name: () => this.$t("salesman"),
          align: "left",
          key: "salesman_name",
          width: 100,
        },
        {
          name: () => this.$tz("财务,备注"),
          align: "left",
          key: "cw_remarks",
          minWidth: 80,
        },
        {
          name: () => this.$t("finances") + this.$t("personnel"),
          align: "left",
          key: "accounting_name",
          width: 100,
        },
        {
          name: () => this.$t("operation") + this.$t("Remarks"),
          align: "left",
          key: "remark",
          minWidth: 130,
        },
      ],
    };
  },
};
</script>
